var youboralib = require('youboralib');

var Util = youboralib.Util;
module.exports = {
  isUsed: function isUsed(adapter) {
    return !!adapter.getTech().hls_;
  },
  getResource: function getResource(adapter) {
    if (adapter.getTech().hls_) {
      return adapter.getTech().hls_.url;
    }

    return adapter.getTech().hls.source_.src;
  },
  getBitrate: function getBitrate(adapter) {
    var currentLevel = adapter.getTech().hls_.currentLevel;

    if (typeof currentLevel === 'undefined' || currentLevel === -1 || !adapter.getTech().hls_.levels) {
      return null;
    }

    var level = adapter.getTech().hls_.levels[currentLevel];
    if (level && level.bitrate) return level.bitrate;
    return null;
  },
  getRendition: function getRendition(adapter) {
    var currentLevel = adapter.getTech().hls_.currentLevel;

    if (typeof currentLevel === 'undefined' || currentLevel === -1 || !adapter.getTech().hls_.levels) {
      return null;
    }

    var level = adapter.getTech().hls_.levels[currentLevel];

    if (level) {
      return Util.buildRenditionString(level.width, level.height, level.bitrate);
    }

    return null;
  }
};